{
  "version": 1,
  "asset_id": "90805f0f-d895-4f3c-bc84-a5396ea7442d",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/90805f0f-d895-4f3c-bc84-a5396ea7442d/svc-web-design-640.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/90805f0f-d895-4f3c-bc84-a5396ea7442d/svc-web-design-640.avif",
  "original_filename": "svc-web-design-640.avif",
  "size": 3160,
  "content_type": "image/avif",
  "created_at": "2026-07-25T02:27:01Z"
}
